export default __webpack_public_path__ + "static/media/fluz-logo-full.ee6cfbbb.svg";